import { Pipe, PipeTransform } from '@angular/core';
import { SupplierService } from 'src/services/suppliers/supplier.service';
import { StockCategories } from 'src/models/stock/stockCategories.enum';

@Pipe({
    name: 'stockCategory',
    standalone: false
})
export class StockCategoryPipe implements PipeTransform {

	constructor(private supplierService: SupplierService) {
	}

	transform(value: StockCategories | undefined): string {
		// 0 is a valid value -> explicit undefined check
		if (value === undefined) {
			return '';
		}
		return this.supplierService.getStockCategoryDisplayName(value);
	}

}
